"use client"

import { Label } from "@/components/ui/label"
import { __ } from "@/i18n"
import { ICON_LIBRARY } from "../constants/widget-config"
import { useWidgetStore } from "../stores/widget-store"

export function IconSelector() {
  const iconId = useWidgetStore((state) => state.config.iconId)
  const setIconId = useWidgetStore((state) => state.setIconId)

  return (
    <div className="cy:space-y-3">
      <div className="cy:flex cy:items-center cy:space-x-2">
        <Label>{__( 'Shape', 'accessibility-widget' )}</Label>
      </div>
      <div className="cy:flex-1 cy:space-x-2">
        {ICON_LIBRARY.map((iconItem) => {
          const IconComponent = iconItem.icon
          return (
            <button
              key={iconItem.id}
              onClick={() => setIconId(iconItem.id)}
              className={`cy:h-[48px] cy:flex-1 cy:justify-items-center cy:w-[56px] cy:border-1 cy:rounded-md cy:transition-all ${
                iconId === iconItem.id ? "cy:border-blue-500 cy:bg-blue-50" : "cy:border-gray-200 cy:hover:border-gray-300 cy:hover:cy:border-gray-300"
              }`}
            >
              <IconComponent className="cy:text-dark cy:w-[24px]"  />
            </button>
          )
        })}
      </div>
    </div>
  )
}
